import { application } from './application';

import UserTypeSelectController from './user_type_select_controller';
import NetworkProfileController from './network_profile_controller';
import ProgressCircleController from './progress_circle_controller';
import CountdownController from './countdown_controller';
import AhoyController from './ahoy_controller';
import YoutubeModalController from './youtube_modal_controller';
import LibrariesRessourceModalController from './libraries_resource_modal_controller';
import CopyController from './copy_controller';
import LemonwayIframeController from './lemonway_iframe_controller';
import StripePaymentController from './stripe_payment_controller';
import ActiveBtnFilterController from './active_btn_filter_controller';
import SearchFilterController from './search_filter_controller';
import PaymentTogglerController from './memberships/renewals/payment_toggler_controller';
import InvestorSelectController from './distributors/investor_select_controller';
import RecapController from './distributors/recap_controller';
import PaymentMethodController from './distributors/payment_method_controller';
import SubscriptionConfirmController from './distributors/subscription_confirm_controller';

// Fundraising controllers
import FundraisingSubscriptionFormController from './fundraisings/fundraising_subscription_form_controller';
import EmailModalController from './fundraisings/email_modal_controller';
import InvestorFormController from './fundraisings/investor_form_controller';
import PhoneInputController from './fundraisings/phone_input_controller';
import AddressFieldsController from './fundraisings/address_fields_controller';
import CardPaymentModalController from './fundraisings/card_payment_modal_controller';
import WirePaymentModalController from './fundraisings/wire_payment_modal_controller';
import RewardProgressController from './fundraisings/reward_progress_controller';

application.register('user-type-select', UserTypeSelectController);
application.register('network-profile', NetworkProfileController);
application.register('progress-circle', ProgressCircleController);
application.register('countdown', CountdownController);
application.register('ahoy', AhoyController);
application.register('youtube-modal', YoutubeModalController);
application.register('libraries-resource-modal', LibrariesRessourceModalController);
application.register('copy', CopyController);
application.register('lemonway-iframe', LemonwayIframeController);
application.register('stripe-payment', StripePaymentController);
application.register('active-btn-filter', ActiveBtnFilterController);
application.register('search-filter', SearchFilterController);
application.register('payment-toggler', PaymentTogglerController);
application.register('investor-select', InvestorSelectController);
application.register('recap', RecapController);
application.register('payment-method', PaymentMethodController);
application.register('subscription-confirm', SubscriptionConfirmController);
application.register('fundraising-subscription-form', FundraisingSubscriptionFormController);
application.register('email-modal', EmailModalController);
application.register('investor-form', InvestorFormController);
application.register('phone-input', PhoneInputController);
application.register('address-fields', AddressFieldsController);
application.register('card-payment-modal', CardPaymentModalController);
application.register('wire-payment-modal', WirePaymentModalController);
application.register('reward-progress', RewardProgressController);
